import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { logOut } from '../actions/user';

import { translations } from '../i18n/translations';

class NavbarAdmin extends Component{

    logOut = (e) => {
        e.preventDefault();
        this.props.logOut();
    }

	render(){

        return(
            <nav className="navbar navbar-inverse navbar-admin">
                <div className="clearfix">
                    <div className="navbar-header">
                        <button type="button" className="navbar-toggle collapsed" 
                            data-toggle="collapse" data-target="#navbar" aria-expanded="false">
                            <span className="sr-only">Toggle navigation</span>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                        </button>
                    </div>
                    <div className="collapse navbar-collapse" id="navbar">
                    { 
                        this.props.user.userInfo ?

                            <ul className="nav navbar-nav navbar-right">
                                <li>
                                    <span>
                                        <i className="icon ion-person"></i> &nbsp;
                                        { this.props.user.userInfo.name }
                                    </span>
                                </li>
                                <li>
                                    <NavLink to="/profile">
                                        <i className="icon ion-compose"></i> Change Password
                                    </NavLink>
                                </li>
                                <li>
                                    <a onClick={this.logOut}>
                                        <i className="icon ion-android-exit"></i> { translations.logout }
                                    </a>
                                </li>
                            </ul>
                        :
                            null
                        }
                    </div>
                </div>
            </nav>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
	user: state.user
});

function mapDispatchToProps(dispatch){
    return bindActionCreators({ logOut }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(NavbarAdmin);



// WEBPACK FOOTER //
// ./src/components/NavbarAdmin.jsx